import avatar1 from '../../../../assets/images/lg/avatar1.jpg';
import avatar2 from '../../../../assets/images/lg/avatar2.jpg';
import avatar3 from '../../../../assets/images/lg/avatar3.jpg';
import avatar4 from '../../../../assets/images/lg/avatar4.jpg';
import avatar5 from '../../../../assets/images/lg/avatar5.jpg';
import avatar6 from '../../../../assets/images/lg/avatar6.jpg';
import avatar7 from '../../../../assets/images/lg/avatar7.jpg';
import avatar8 from '../../../../assets/images/lg/avatar8.jpg';

export const empData = [
    {
        empName:'Luke Short',
        role:'Master Safe',
        jobDescription:'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices',
        empImg: avatar1
    },
    {
        empName:'Lillian Powell',
        role:'Bar Tender',
        jobDescription:'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices',
        empImg: avatar2
    },
    {
        empName:'Rachel Parsons',
        role:'Manager',
        jobDescription:'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices',
        empImg: avatar3
    },
    {
        empName:'John Hardacre',
        role:'Housekeeping Staff',
        jobDescription:'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices',
        empImg: avatar4
    },
    {
        empName:'Jan Ince',
        role:'Receptionist',
        jobDescription:'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices',
        empImg: avatar5
    },
    {
        empName:'Steven Butler',
        role:'Receptionist',
        jobDescription:'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices',
        empImg: avatar6
    },
    {
        empName:'Robert Hammer',
        role:'Master Safe',
        jobDescription:'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices',
        empImg: avatar7
    },
    {
        empName:'Paul Slater',
        role:'Receptionist',
        jobDescription:'Vestibulum ante ipsum primis in faucibus orci luctus et ultrices. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices',
        empImg: avatar8
    },
]